import React, { useEffect, useState } from "react";
import styles from "./changeLogs.module.css";
import { useDispatch, useSelector } from "react-redux";
import { loadingOff, loadingOn, selectLoadingUI } from "../../reducers/uiSlice";
import service from "../../utils/services/records";
import { selectCompany } from "../../reducers/companySlice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import lumaUtils from "@lumarketo/luma-utils";
import { selectSubsidiaries } from "../../reducers/subsidiarySlice";
import { ClockIcon } from "../sideBar/sideBarIcons";
import { CircularProgress } from "@material-ui/core";

const ChangeLogs = ({
  subsidiaryId = undefined,
  subtitle,
  module,
  submodule = undefined,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const loading = useSelector(selectLoadingUI);
  const company = useSelector(selectCompany);

  return (
    <>
      <button
        type="button"
        className={styles.changeLogsBtn}
        onClick={() => setOpenModal(true)}
        disabled={loading || !company}
      >
        <FileClockIcon /> Ver registro de cambios
      </button>
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          openModal={openModal}
          subsidiaryId={subsidiaryId}
          subtitle={subtitle}
          module={module}
          submodule={submodule}
        />
      )}
    </>
  );
};

const Modal = ({
  openModal,
  setOpenModal,
  subsidiaryId,
  subtitle,
  module,
  submodule,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoadingUI);
  const company = useSelector(selectCompany);
  const [page, setPage] = useState(1);
  const [recordsData, setRecordsData] = useState();
  const subsidiaries = useSelector(selectSubsidiaries);
  /*   const subsiDiaryName = subsidiaries?.find(
    (f) => f?._id === subsidiaryId
  )?.Name; */
  const getLogs = async (page) => {
    dispatch(loadingOn());
    try {
      const records = await service.getRecords({
        companyId: company?._id,
        limit: 20,
        page,
        subsidiaryId,
        orderBy: "createdAt",
        order: "desc",
        module,
        submodule,
      });
      if (records) {
        setRecordsData(records);
      }
    } catch (error) {
      console.error("error trying to get logs", error);
    } finally {
      dispatch(loadingOff());
    }
  };
  const handleChangePage = (newPage) => {
    if (!recordsData) return;
    if (newPage < 1 || newPage > recordsData.pageCount) return;
    setPage(newPage);
    getLogs(newPage);
  };

  const uselogsData = () => {
    if (!recordsData?.items?.length) return [];

    return recordsData?.items?.map((item) => {
      const {
        user: { email, fullName },
        module,
        submodule,
        subsidiaryId,
        changes,
      } = item;

      const subsidiaryData = subsidiaries?.find(
        (f) => f?._id === subsidiaryId
      )?.Name;
      const initials = fullName.slice(0, 2);
      return (
        <div className={styles.boxContainer} key={item?._id}>
          <div className={styles.iconUserModuleContainer}>
            <div className={styles.nameInitialsContainer}> {initials}</div>

            <div className={styles.userModuleOuterContainer}>
              <div className={styles.userModuleContainer}>
                <div className={styles.nameContainer}>
                  <p className={styles.name}>{fullName}</p>
                  <p className={styles.email}>{email}</p>
                </div>

                <div className={styles.dateContainer}>
                  <ClockIcon width="14" height="14" />
                  <p className={styles.dateElement}>
                    {lumaUtils.dateUtils.momentLib(item?.createdAt)
                      .tz("America/Santiago")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>{" "}
                </div>
              </div>
              <div className={styles.subsidiaryModuleContainer}>
                <div className={styles.subsidiaryIconContainer}>
                  <SmallLocationIcon />
                  <p className={styles.subsidiaryElement}>
                    {subsidiaryId === "all" ? "Todas" : subsidiaryData}
                  </p>
                </div>
                <div className={styles.moduleContainer}>
                  <p className={styles.moduleElement}>{module}</p>
                </div>
                <p className={styles.subModuleElement}>{submodule}</p>
              </div>
            </div>
          </div>

          <div className={styles.valuesContainer}>
            <p className={styles.titleValues}>Cambios realizados</p>
            {changes?.map((item) => {
              const { newValue, oldValue, text, _id } = item;
              return (
                <div className={styles.valuesInputOuterContainer} key={_id}>
                  <div className={styles.valuesContainerInput}>
                    <p className={styles.valuesTitle}>Valor anterior:</p>
                    <p className={styles.valueselement}>{oldValue}</p>
                  </div>
                  <div className={styles.valuesContainerInput}>
                    <p className={styles.valuesTitle}>Valor nuevo:</p>
                    <p className={styles.valueselement}>{newValue}</p>
                  </div>
                  {text ? (
                    <div className={styles.valuesContainerInput}>
                      <p className={styles.valuesTitle}>Observación:</p>
                      <p className={styles.valueselement}>{text}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  useEffect(() => {
    if (company) {
      getLogs(1);
    }
    // eslint-disable-next-line
  }, [company]);
  if (!openModal) return null;
  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.btnTitleIcontContainer}>
          <div className={styles.btnTitleContainer}>
            <div className={styles.iconContainer}>
              <RefreshClockwiseIcon />
            </div>
            <div className={styles.titleContainer}>
              <p className={styles.titleModal}>Registro de cambios</p>
              <p className={styles.subTtleModal}>
                {subtitle}
                {/*   <strong>{subsiDiaryName}</strong> */}
              </p>
            </div>
          </div>
          <button
            type="button"
            className={styles.closebtn}
            onClick={() => setOpenModal(false)}
          >
            <CloseOutlinedIcon />
          </button>
        </div>

        <div className={styles.tableContainer}>
          {loading ? (
            <div className={styles.circularProgressContainer}>
              <CircularProgress className={styles.circularProgressElement} />
            </div>
          ) : (
            uselogsData()
          )}
        </div>
        <div className={styles.paginationContainer}>
          <div className={styles.Pagination}>
            <button
              onClick={() => handleChangePage(page - 1)}
              disabled={!recordsData?.prev}
              className={styles.btnPagination}
            >
              Anterior
            </button>

            <p className={styles.paginationsText}>
              Página {page} de {recordsData?.pageCount}
            </p>

            <button
              onClick={() => handleChangePage(page + 1)}
              disabled={!recordsData?.next}
              className={styles.btnPagination}
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeLogs;

const FileClockIcon = ({
  width = 16,
  height = 16,
  stroke = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth="1.33333"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    <path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" />
    <path d="M8 14v2.2l1.6 1" />
    <circle cx="8" cy="16" r="6" />
  </svg>
);
const SmallLocationIcon = ({ width = 12, height = 13, stroke = "#0A0A0A" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g clipPath="url(#clip0_4_474)">
      <path d="M10 5.20312C10 7.69963 7.2305 10.2996 6.3005 11.1026C6.21386 11.1678 6.1084 11.203 6 11.203C5.8916 11.203 5.78614 11.1678 5.6995 11.1026C4.7695 10.2996 2 7.69963 2 5.20312C2 4.14226 2.42143 3.12484 3.17157 2.3747C3.92172 1.62455 4.93913 1.20313 6 1.20312C7.06087 1.20313 8.07828 1.62455 8.82843 2.3747C9.57857 3.12484 10 4.14226 10 5.20312Z" />
      <path d="M6 6.70312C6.82843 6.70312 7.5 6.03155 7.5 5.20312C7.5 4.3747 6.82843 3.70312 6 3.70312C5.17157 3.70312 4.5 4.3747 4.5 5.20312C4.5 6.03155 5.17157 6.70312 6 6.70312Z" />
    </g>
    <defs>
      <clipPath id="clip0_4_474">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.203125)"
        />
      </clipPath>
    </defs>
  </svg>
);

const RefreshClockwiseIcon = ({
  width = 20,
  height = 21,
  stroke = "#155DFC",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
    strokeWidth="1.66667"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2.5 10.2031C2.5 11.6865 2.93987 13.1365 3.76398 14.3699C4.58809 15.6033 5.75943 16.5646 7.12987 17.1322C8.50032 17.6999 10.0083 17.8484 11.4632 17.559C12.918 17.2696 14.2544 16.5553 15.3033 15.5064C16.3522 14.4575 17.0665 13.1212 17.3559 11.6663C17.6453 10.2114 17.4968 8.70344 16.9291 7.333C16.3614 5.96255 15.4001 4.79121 14.1668 3.9671C12.9334 3.14299 11.4834 2.70312 10 2.70312C7.90329 2.71101 5.89081 3.52914 4.38333 4.98646L2.5 6.86979" />
    <path d="M2.5 2.70312V6.86979H6.66667" />
    <path d="M10 6.03645V10.2031L13.3333 11.8698" />
  </svg>
);
